import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";

export function DialogFita({
    isVisibleFita, setIsVisibleFita,
    isVisibleFitaCE, setIsVisibleFitaCE,
    listaFitas, fita, setFita,
    salvarFita, deletarFita,
}) {
    const abrirNovo = () => {
        setFita({ id: null, nr_serie: '', validade: null, passadas_programadas: null });
        setIsVisibleFitaCE(true);
    };

    const abrirEdicao = (rowData) => {
        setFita({ ...rowData });
        setIsVisibleFitaCE(true);
    };

    return (
        <>
            {/* Listagem */}
            <Dialog
                header="Fitas Cadastradas"
                onHide={() => setIsVisibleFita(false)}
                style={{ minWidth: '50vw' }}
                visible={isVisibleFita}
            >
                <div className="p-fluid">
                    <div className="p-d-flex p-flex-row p-jc-end p-ai-center p-m-1">
                        <Button className="p-m-1" icon="pi pi-plus" onClick={abrirNovo} title="Cadastrar uma fita" />
                    </div>
                    <DataTable
                        value={listaFitas}
                        className="p-m-1"
                        emptyMessage="Nenhum registro lançado até o momento"
                        responsiveLayout="scroll"
                        size="small"
                    >
                        <Column header="Nº Série" field="nr_serie" sortable style={{ width: "40%" }} />
                        <Column header="Validade" field="validade" style={{ width: "25%" }}
                            body={(row) => `${row.validade} anos`} />
                        <Column header="Passadas Programadas" field="passadas_programadas" style={{ width: "25%" }} />
                        <Column
                            header="Ação"
                            style={{ textAlign: 'center' }}
                            headerStyle={{ display: 'flex', justifyContent: 'center' }}
                            body={(row) => (
                                <div style={{ display: 'flex', gap: 5, justifyContent: 'center' }}>
                                    <Button icon="pi pi-pencil" className="p-button-rounded p-button-text"
                                        onClick={() => abrirEdicao(row)} />
                                    <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => deletarFita(row)} />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </Dialog>

            {/* Cadastro / Edição */}
            <Dialog
                visible={isVisibleFitaCE}
                style={{ width: '450px' }}
                header={fita.id ? "Editar Fita" : "Cadastrar Nova Fita"}
                modal
                className="p-fluid"
                onHide={() => setIsVisibleFitaCE(false)}
                footer={
                    <div>
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text"
                            onClick={() => setIsVisibleFitaCE(false)} />
                        <Button label="Salvar" icon="pi pi-check" onClick={salvarFita} autoFocus />
                    </div>
                }
            >
                <div className="p-field p-mt-3">
                    <label htmlFor="nr_serie">Nº de Série</label>
                    <InputText id="nr_serie" maxLength={32} required value={fita.nr_serie}
                        onChange={(e) => setFita({ ...fita, nr_serie: e.target.value })} />
                </div>
                <div className="p-field p-mt-3">
                    <label htmlFor="fita_validade">Validade (em Anos)</label>
                    <InputNumber id="fita_validade" min={1} required value={fita.validade}
                        onValueChange={(e) => setFita({ ...fita, validade: e.value })} />
                </div>
                <div className="p-field p-mt-3">
                    <label htmlFor="passadas_programadas">Passadas Programadas</label>
                    <InputNumber id="passadas_programadas" min={1} required value={fita.passadas_programadas}
                        onValueChange={(e) => setFita({ ...fita, passadas_programadas: e.value })} />
                </div>
            </Dialog>
        </>
    );
}